/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalSearchClientContextDto } from './GlobalSearchClientContextDto';
import {
    GlobalSearchClientContextDtoFromJSON,
    GlobalSearchClientContextDtoFromJSONTyped,
    GlobalSearchClientContextDtoToJSON,
    GlobalSearchClientContextDtoToJSONTyped,
} from './GlobalSearchClientContextDto';

/**
 * Item de résultat (forme identique quel que soit le type). Les champs null sont omis du JSON — tout est optionnel sauf type, id, title.
 * 
 * @export
 * @interface GlobalSearchItemDto
 */
export interface GlobalSearchItemDto {
    /**
     * client | contrat | devis | simulation | note | contratGroupe
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    type: string;
    /**
     * Id de l'objet lui-même
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    id: string;
    /**
     * Libellé principal (nom client, n° contrat/devis, n° dossier, titre note…)
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    title: string;
    /**
     * Contexte humain, séparateur « · » (email · tél ; assuré · produit ; extrait note…)
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    subtitle?: string | null;
    /**
     * Statut lisible (Particulier / Personne morale, statut métier…)
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    badge?: string | null;
    /**
     * Couleur du statut (mêmes valeurs que les listes) — contrat/devis/simulation
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    badgeColor?: string | null;
    /**
     * Id du risque assuré -> navigation vers le dossier
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    riskId?: string | null;
    /**
     * Dossiers EMPRUNTEUR uniquement : id du projet d'emprunt (un projet contient plusieurs risques). Indispensable pour les routes emprunteur (/simulation/.../emprunteur|borrower/{borrowerProjectId}/...), le riskId seul ne suffit pas.
     * 
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    borrowerProjectId?: string | null;
    /**
     * Id personne -> navigation vers la fiche client
     * @type {string}
     * @memberof GlobalSearchItemDto
     */
    personId?: string | null;
    /**
     * Dernière modification
     * @type {Date}
     * @memberof GlobalSearchItemDto
     */
    date?: Date | null;
    /**
     * Contexte enrichi — uniquement sur les 3 premiers items du groupe client
     * @type {GlobalSearchClientContextDto}
     * @memberof GlobalSearchItemDto
     */
    context?: GlobalSearchClientContextDto | null;
}

/**
 * Check if a given object implements the GlobalSearchItemDto interface.
 */
export function instanceOfGlobalSearchItemDto(value: object): value is GlobalSearchItemDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function GlobalSearchItemDtoFromJSON(json: any): GlobalSearchItemDto {
    return GlobalSearchItemDtoFromJSONTyped(json, false);
}

export function GlobalSearchItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'badge': json['badge'] == null ? undefined : json['badge'],
        'badgeColor': json['badgeColor'] == null ? undefined : json['badgeColor'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'context': json['context'] == null ? undefined : GlobalSearchClientContextDtoFromJSON(json['context']),
    };
}

export function GlobalSearchItemDtoToJSON(json: any): GlobalSearchItemDto {
    return GlobalSearchItemDtoToJSONTyped(json, false);
}

export function GlobalSearchItemDtoToJSONTyped(value?: GlobalSearchItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'title': value['title'],
        'subtitle': value['subtitle'],
        'badge': value['badge'],
        'badgeColor': value['badgeColor'],
        'riskId': value['riskId'],
        'borrowerProjectId': value['borrowerProjectId'],
        'personId': value['personId'],
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
        'context': GlobalSearchClientContextDtoToJSON(value['context']),
    };
}

